import React from "react";
import "./CertifiedStyle.scss";
import { certifiedTextContent } from "./constant/index";
import SectionHeading from "../Common_UI_Kit/SectionHeading";
import useEmblaCarousel from "embla-carousel-react";
import AutoScroll from "embla-carousel-auto-scroll";

const CertifiedSection = () => {
  const [emblaRef, emblaApi] = useEmblaCarousel(
    {
      slidesToScroll: "auto",
      align: "start",
      loop: true,
    },
    [AutoScroll({ playOnInit: true, stopOnInteraction: false, speed: 1.5, startDelay: 0 })]
  );

  return (
    <section className="certified-section">
      <div className="certified-wrap">
        {/* <SectionHeading>{certifiedTextContent.headingText}</SectionHeading> */}

        <h5 className="subtitle-text">{certifiedTextContent.subtitleText}</h5>

        <div className="embla">
          <div className="embla__viewport" ref={emblaRef}>
            {certifiedTextContent.certifiedContent.map((provider, index) => (
              <div className="embla__container" key={index}>
                {provider.imageContent.map((image, imgIndex) => (
                  <div className="embla__slide">
                    <div className="logo-img-box">
                      <img
                        src={image.imageSrc}
                        key={imgIndex}
                        alt={`Provider Logo ${imgIndex + 1}`}
                      />
                    </div>
                  </div>
                ))}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default CertifiedSection;
